module.exports = __webpack_public_path__ + "static/media/mobileload.fbbdb088.svg";